import { Component, OnInit } from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../shared/animations/custom-animations';

@Component({
  selector: 'app-trouble-signing-in-page',
  templateUrl: './trouble-signing-in-page.component.html',
  styleUrls: ['./trouble-signing-in-page.component.css'],
  animations: [
    trigger('showComponentWindow', smoothEnterLeaveAnimation('100ms 100ms', '100ms'))
  ]
})
export class TroubleSigningInPageComponent implements OnInit {

  troubleSigningInAction;

  constructor() { }

  ngOnInit(): void {
  }

}
